import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Card } from '@box-types';
import { getPaymentCardBrand } from '@box/utils';

@Component({
  selector: 'account-card',
  templateUrl: './account-card.component.html',
  styleUrls: ['./account-card.component.scss']
})
export class AccountCardComponent implements OnInit, OnChanges {
  @Input() public card: Card;
  @Input() public canEdit = true;
  @Input() public canDelete = true;
  @Output() private editCard: EventEmitter<Card> = new EventEmitter<Card>();
  @Output() private deleteCard: EventEmitter<Card> = new EventEmitter<Card>();

  public imageUrl: string;

  ngOnInit(): void {
    this.setImage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.card) {
      this.card = changes.card.currentValue as Card;
      this.setImage();
    }
  }

  private setImage(): void {
    this.imageUrl = '/assets/images/payments/' + getPaymentCardBrand(this.card) + '.svg';
  }

  public onEdit(card: MouseEvent): void {
    this.editCard.emit(card as Card);
  }

  public onDelete(card: Card): void {
    this.deleteCard.emit(card);
  }
}
